var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "results-recently-opened" },
    _vm._l(_vm.results.slice(0, 8), function(result, index) {
      return _c(
        _vm.componentName(result),
        _vm._b(
          {
            key: index,
            tag: "component",
            attrs: { context: "recently-viewed" }
          },
          "component",
          result.items,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }